/** Plain ordered or bulleted list. */
export function List({ ordered, items }: { ordered: boolean; items: string[] }) {
  const body = items.map((it, i) => <li key={i}>{it}</li>)
  return ordered ? <ol className="blist">{body}</ol> : <ul className="blist">{body}</ul>
}
